import type { BBox, Stroke } from '@blackboard/shared';
import { TILE_SIZE } from '@blackboard/shared';

const loadedTiles = new Set<string>();

export function resetTileCache() {
  loadedTiles.clear();
}

/** 撤销擦除/回滚后，让覆盖该区域的瓦片缓存失效——否则平移回来时缓存
 *  命中（旧数据里这些笔画还是被擦状态），恢复的内容会凭空消失。 */
export function invalidateTiles(b: BBox) {
  const tx1 = Math.floor(b.x1 / TILE_SIZE);
  const ty1 = Math.floor(b.y1 / TILE_SIZE);
  const tx2 = Math.floor(b.x2 / TILE_SIZE);
  const ty2 = Math.floor(b.y2 / TILE_SIZE);
  if (tx2 - tx1 > 64 || ty2 - ty1 > 64) {
    // 超大范围（整板回滚）直接全失效，避免 O(瓦片数) 遍历
    loadedTiles.clear();
    return;
  }
  for (let x = tx1; x <= tx2; x++) {
    for (let y = ty1; y <= ty2; y++) {
      loadedTiles.delete(`${currentSlug}::${x}:${y}`);
    }
  }
}

let currentSlug = '';
export function setCurrentTileScope(slug: string) {
  currentSlug = slug;
}

export function tilesInBBox(b: BBox): { x: number; y: number }[] {
  const tx1 = Math.floor(b.x1 / TILE_SIZE);
  const ty1 = Math.floor(b.y1 / TILE_SIZE);
  const tx2 = Math.floor(b.x2 / TILE_SIZE);
  const ty2 = Math.floor(b.y2 / TILE_SIZE);
  const out: { x: number; y: number }[] = [];
  for (let x = tx1; x <= tx2; x++) {
    for (let y = ty1; y <= ty2; y++) {
      out.push({ x, y });
    }
  }
  return out;
}

export async function loadTile(slug: string, token: string, tx: number, ty: number): Promise<Stroke[]> {
  const key = `${slug}::${tx}:${ty}`;
  if (loadedTiles.has(key)) return [];
  loadedTiles.add(key);
  try {
    const res = await fetch(`/api/boards/${slug}/tiles/${tx}/${ty}`, {
      headers: { authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      loadedTiles.delete(key);
      return [];
    }
    const body = await res.json();
    return body.strokes as Stroke[];
  } catch {
    loadedTiles.delete(key);
    return [];
  }
}

export async function loadDelta(slug: string, token: string, since: number): Promise<Stroke[]> {
  try {
    const res = await fetch(`/api/boards/${slug}/delta?since=${since}`, {
      headers: { authorization: `Bearer ${token}` },
    });
    if (!res.ok) return [];
    const body = await res.json();
    return body.strokes as Stroke[];
  } catch {
    return [];
  }
}
